<script setup>

	import {onMounted, ref} from "vue";
	import useScavenge from "../composables/scavenger.js";
	const { closeModal, getSession, claimClue, toggleLoader, changeModal } = useScavenge()

	const answer = ref('')
	const error = ref(false)

	const checkAnswer = async () => {
		error.value = false
		let la = answer.value.slice()
		console.log('b', la)
		la = la.trim().toLowerCase()
		console.log('a', la)
		if(la === 'earth-1610') {
			changeModal('clue-4')
		} else {
			error.value = true
		}
	}

	onMounted(async() => {
		// mark clue as claimed for the week
		toggleLoader(true)
		await claimClue(3)
		toggleLoader(false)
	})
</script>

<template>
	<div class="scavenger-modal-body">
		<h6 class="modal-heading">Clue #03</h6>
		<p>Not all Fibre providers may be available in your area. The Fibre Coverage Tool can help you check which providers are in your area. Use the coverage tool below to check Fibre availability on Earth-1610.</p>
		<form @submit.prevent="checkAnswer">
			<label class="spm-input"><input type="text" placeholder="What's the address?" v-model="answer"></label>
			<div class="error" v-if="error">
				<svg width="15px" height="13.3496276px" viewBox="0 0 15 13.3496276"><path d="M8.32572857,8.11206422 C8.32572857,8.56820455 7.95598185,8.93795127 7.49984153,8.93795127 C7.04375716,8.93795127 6.67395448,8.56820455 6.67395448,8.11206422 L6.67395448,4.77539104 C6.67395448,4.31930667 7.04375716,3.949504 7.49984153,3.949504 C7.95598185,3.949504 8.32572857,4.31930667 8.32572857,4.77539104 L8.32572857,8.11206422 Z M6.67401044,10.8300495 C6.67719984,10.3782737 7.05645881,9.99951827 7.50319879,10.0018684 C7.95301627,10.0042184 8.32673575,10.3830298 8.32573263,10.835645 C8.32472139,11.2932961 7.95844385,11.6555449 7.49749144,11.6547085 C7.03849744,11.6538663 6.67076508,11.2856303 6.67401044,10.8300495 Z M14.1039723,10.181426 C12.2908257,7.04092902 10.480309,3.89880931 8.65854538,0.76323626 C8.53320751,0.547532022 8.35426532,0.33367428 8.14779356,0.199775384 C7.52815446,-0.202033211 6.76633521,0.0221201428 6.37678063,0.694132568 C5.46377258,2.26896935 4.55580042,3.84677171 3.64553413,5.42323116 C2.50507141,7.39830981 1.36673496,9.37467541 0.221404207,11.3469563 C0.0256756923,11.6839138 -0.0557379696,12.0326216 0.0403917012,12.408971 C0.184977888,12.9755094 0.674858719,13.3468228 1.27435423,13.3475502 C3.34752096,13.3501801 5.42074364,13.3485574 7.49391036,13.3487812 C9.55314444,13.3489491 11.6123785,13.3509634 13.6715566,13.3481097 C14.742468,13.3466549 15.3308846,12.3301312 14.8040179,11.3958605 C14.5745489,10.9889041 14.3376379,10.5860883 14.1039723,10.181426 Z" fill="#DA291C"></path></svg>
				<p>That's not quite right, try again.</p>
			</div>
			<button class="scb" @click.prevent="checkAnswer">Check coverage</button>
		</form>
	</div>
</template>
